window.c_array = {};

window.c_array['ash'] = 'ASH';
window.c_array['black'] = 'BLK';
window.c_array['brown'] = 'BRN';
window.c_array['chestnut'] = 'CST';
window.c_array['chocolate'] = 'CHC';
window.c_array['gray'] = 'GRY';
window.c_array['natural Gray'] = 'NGY';
window.c_array['vanilla'] = 'VAN';
window.c_array['white'] = 'LIM';
window.c_array['rustic gray'] = 'RGR';
window.c_array['rustic coffee'] = 'RCF';
window.c_array['rustic moss stone'] = 'RMS';
window.c_array['rustic white'] = 'RWH';
window.c_array['metallic bronze'] = 'MBR';
window.c_array['metallic copper'] = 'MCP';
window.c_array['metallic pearl'] = 'MPR';
window.c_array['metallic silver'] = 'MSV';
window.c_array['metallic slate'] = 'MSL';

window.c_array['match lit'] = 'RF37';
window.c_array['match lit with flame sense'] = 'RF37FSML';
window.c_array['spark ignition with flame sense'] = 'RF37FSEN';
window.c_array['low voltage electronic ignition'] = 'RF37E12V';
window.c_array['plug & play electronic ignition'] = 'RF37EKIT';

window.c_array['liquid propane'] = 'LP';
window.c_array['natural gas'] = 'NG';

window.get_sku = function (){
  // var sku_number = [];
  // sku_number.push($('.variations_form_ppr').attr('data-sku'));
  // $('#ymq-box .ymq-options-box input[type="radio"]:checked').each(function(ii,vv){
  //   if(typeof(window.c_array[$(vv).val().toLowerCase()]) !== 'undefined' && (window.c_array[$(vv).val().toLowerCase()]) != null){
  //     sku_number.push(window.c_array[$(vv).val().toLowerCase()]); 
  //   }
  // });
  // var a_sku = sku_number.join('-');
  // console.log(a_sku); 
  // $('#pr_sku_ppr').html(a_sku);
  // $('input[name="properties[_YmqItemSku]"]').val(a_sku);
  
}

/* collection-swatch */    
$(document).ready(function(){
  $("body").on(
    "click",
    "#callBackVariant_ppr .combine-swatch-option .swatch__title",
    function () {
      $(this).closest('[data-opname]').toggleClass('active');
     });
  $('body').on("click",".tab-links a",function(e) {
    e.preventDefault();
    $(this).closest('.tab-section').find('.tab-links a').removeClass("active");
    $(this).closest('.tab-section').find(this).addClass("active");
    var id = $(this).attr("href");
    $('.tab-section').find('.tab-content').hide();
    $(this).closest('.tab-section').find(id).show();
  });
  
  $(".custom-swatch a").mouseover(function(event){
    var data_img = $(this).attr("data-image");
    console.log("hans"+data_img);
    if(data_img == undefined){
      alert("Not Found Image");
    }else{
      var img ='background-image: url("'+data_img+'");';
      var image_variant = $(this).parents('.product-inner').find(".main-img").attr("style",img);
    }
  });
  $('body').on('click', '.video-rd',function(e){
    e.preventDefault();
    $(this).closest('.product-intro').find('.popup-vid').show();
  });
  $('body').on('click', '.content_video_button',function(e){
    e.preventDefault();
    $(this).closest('.product-intro-vid').find('.popup-vid').show();
  });
  $('body').on('click', '.popup-vid-bg, .close-popup',function(e){
    e.preventDefault();
    if($(this).closest('.product-intro').length){
      $(this).closest('.product-intro').find('.popup-vid').hide(); 
    }else{
      $(this).closest('.product-intro-vid').find('.popup-vid').hide();  
    }
  });
  
  if($("body .pdp-center-slider-first").length > 0){
   $("body .pdp-center-slider-first").owlCarousel({
      center:true,
      items:1,
      nav:true,
      loop: true,
      margin:10,
      autoplay: true,
      singleItem: true,
      responsive:{
        600:{
          margin:60,
          items:2
        }
      }
    }); 
  }
  function change_main_img(vv,ccc){
    var c_th_img = $(vv).find('.active_thumb_c img'),
    title = c_th_img.attr('data-title'),
    desk_img = c_th_img.attr('data-main-img'),
    mobile_img = c_th_img.attr('data-main-img-mobile'),
    content = c_th_img.attr('data-description');
    $(vv).find('#tab-main-img').attr('src',desk_img);
    $('.popup_thumbnail_mobile_img').attr('src',mobile_img);
    $(vv).find('#tab-main-title').text(title);
    $('.popup_thumbnail_title').text(title);
    $(vv).find('#tab-main-description').text(content);
    $('.popup_thumbnail_content').text(content);
    if(ccc == 1){
      if(window.width < 768){
        $('#pdpProductTabModal').show();
      }
    }
  }
  
  $('.custom_thumbnail_img').each(function(ii,vv){
    change_main_img(vv,0);
  });

  $('body').on('click','#pdpProductTabModal_close',function(e){
    e.preventDefault();
    $('#pdpProductTabModal').hide();
  });
  $('body').on('click','.custom_thumbnail_img .pdp-list-block a',function(e){
    e.preventDefault();
    $(this).closest('.custom_thumbnail_img').find('.pdp-list-block a').removeClass('active_thumb_c');
    $(this).addClass('active_thumb_c');
    var vv = $(this).closest('.custom_thumbnail_img');
    change_main_img(vv,1);
  });
  
  $('body').on('click','.custom_thumbnail_img li.nav-item a.nav-link',function(e){
    e.preventDefault();
    var div_id = $(this).attr('href');
    $(this).closest('.custom_thumbnail_img').find('li.nav-item a.nav-link').removeClass('active show');
    $(this).closest('.custom_thumbnail_img').find('.tab-content .tab-pane').removeClass('active show');
    $(this).addClass('active show');
    $(div_id).addClass('active show');
  });

  $('body').on('click','.vm_bundle .add-pdp',function(e){
    e.preventDefault();
    $(this).closest('.bundle-item').addClass('active');
  });
  $('body').on('click','.vm_bundle .remove-pdp',function(e){
    e.preventDefault();
    $(this).closest('.bundle-item').removeClass('active');
    $(this).closest('.bundle-item').find('input[type="number"]').val(1);
  });
  $('.tfaq-head').click(function(e){
    $(this).parent().toggleClass('active');
    $(this).parent().find('.tfaq-content').slideToggle();
  });
  $('body').on('click','.mobile_tab_section a.heading_tab',function(e){
    e.preventDefault();
    $(this).closest('.mobile_pdp_tab').toggleClass('active');
  });
  $('body').on('click','.new-tab .tab-nav a',function(e){
    e.preventDefault();
    $(this).closest('.new-tab').find('.tab-nav a').removeClass('active');
    $(this).closest('.new-tab').find('.new-tab-content').removeClass('active');
    $(this).addClass('active');
    $($(this).attr('href')).addClass('active');
  });
  if($('.auto-heating-slider').length){
     $('.auto-heating-slider').owlCarousel({
        dots: false,
        nav: true,
        items: 1,
    }); 
  }
  if($('.home-ecosystem-slideshow-inner').length){
    var owl = $('.home-ecosystem-slideshow-inner');
    owl.owlCarousel({
        dots: true,
        nav: false,
        items: 1,
    });
    owl.on('changed.owl.carousel', function(event) {
      $('.ecosystem-slide-nav').removeClass('slide-active');
      $('.ecosystem-slide-nav').eq($('.home-ecosystem-slideshow-inner .owl-dots .owl-dot.active').index()).addClass('slide-active');
    })
  }
  if($('.slider_blogs').length){
    var owlL = $('.slider_blogs');
    owlL.owlCarousel({
        dots: true,
        nav: false,
        items: 1,
        responsive:{
            767:{
                items:2
            }
        }
      
    });
  }
  $('body').on('click','.ecosystem-slide-nav',function(e){
    e.preventDefault();
    $('.home-ecosystem-slideshow-inner .owl-dots .owl-dot').eq($(this).index()).trigger('click');
  });

  $('body').on('click','.ecosystem-slide-nav',function(e){
    e.preventDefault();
    $('.home-ecosystem-slideshow-inner .owl-dots .owl-dot').eq($(this).index()).trigger('click');
  });

  $(document).mouseup(function(e) {
    var container = $("#shopify-section-header_4 .search_header__prs");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      container.hide();
    }
  });

  if($('.box_wrapper, .mrcool_product_list').length > 0){
    $(window).resize(function(){
      if(screen.width > 749){
        $('.box_wrapper, .mrcool_product_list').owlCarousel('destroy');
      }else{
        $(".box_wrapper, .mrcool_product_list").owlCarousel({
          items:1,
          singleItem: true,
          margin: 20
        });
      }
    });  
  }

  $('body').on('click', '#avpoptions-container__v2 .ap-label-tooltip',function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).closest('.ap-options__swatch-container').find('.ap-options__swatch').slideToggle('fast');
  });
  $('body').on('click', ' #avpoptions-container__v2 input[type="radio"]',function(){
    if($(this).closest('.ap-options__swatch-container').find('input[type="radio"]:checked').length > 0){
      $(this).closest('.ap-options__swatch-container').find('.ap-label-tooltip').removeClass('active');
      $(this).closest('.ap-options__swatch-container').find('.ap-options__swatch').slideUp('fast');
      $(this).closest('.ap-options__swatch-container').next().find('.ap-label-tooltip').trigger('click');
    }
  });
});

/* collection-swatch */
$(window).scroll(function(){
  var sticky = $('.sp_header_mid'),
      scroll = $(window).scrollTop();
  if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});

jQuery_T4NT(document).ready(function($) {
   /**
   * Variant selection changed
   */
  $( document ).on( "variant:change", function( evt, variant ) {
    $('.multiple_spec_per_variant').hide();
    if($('.multiple_spec_per_variant[data-variant_title="'+ variant.title +'"]').length){
      $('.multiple_spec_per_variant').closest('.w_50').show();
     $('.multiple_spec_per_variant[data-variant_title="'+ variant.title +'"]').show(); 
    }else{
      $('.multiple_spec_per_variant').closest('.w_50').hide();
    }
    if(variant.title == 'None'){
      console.log('in none');
      $('.is_uni_centeral .bundle-item[data-lineset] [data-bundle-quantity-input]').val(0);
    }else{
      $('.is_uni_centeral .bundle-item[data-lineset] [data-bundle-quantity-input]').val(1);
    }
    $('.pre_order_product_text').remove();
    console.log(variant);
    if(variant.name != null && variant.name != 'undefined'){
      if(variant.name.toLowerCase().indexOf('zline') > -1 
         && window.pre_order_text != '' 
         && window.inv_management[variant.id] == 'shopify' 
         && window.inv_policy[variant.id] == 'continue' 
         && window.inv_qty[variant.id] <= 0){
        $('.nt_cart_form .variations_button').before('<div class="pre_order_product_text fromjs">'+ window.pre_order_text +'</div>');
      }
    }
  });
  $('body').on('click','.extra_products .header_picker',function(e){
    e.preventDefault();
    if($(this).closest('.nt_lt_fake').hasClass('opended')){
      $(this).closest('.nt_lt_fake').removeClass('opended');
    }else{
     $('.extra_products .nt_lt_fake').removeClass('opended');
     $(this).closest('.nt_lt_fake').addClass('opended'); 
    }
  });
  $('body').on('click','.extra_products ul li span.swatch__value_pr',function(e){
    e.preventDefault();
    var value = $(this).closest('li').attr('data-value'),
      price = $(this).closest('li').attr('data-variant_price'),
      variant_id = $(this).closest('li').attr('data-variant_id');
    $(this).closest('.extra_products').find('.header_picker').html(value).attr('data-variant_price',price).attr('data-variant_id',variant_id);
    $('.extra_products .nt_lt_fake').removeClass('opended');
    count_price();
  });
  $(document).mouseup(function(e){
    var container = $(".extra_products ul.swatches-select, .extra_products .header_picker");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      $('.extra_products .nt_lt_fake').removeClass('opended');        
    }
  });
  $(".nt_menu>li:not(.tabbing_list)").hover(function () {
    $('.main_tabbing .menu_item.custom_tab').removeClass('active');
    $(".tabbing_list.menu-item").removeClass('menu_item_hover');
  });
  $(".nt_menu>li.tabbing_list>a").hover(function () {
    $('.main_tabbing .menu_item.custom_tab').removeClass('active');
    $(this).closest('.tabbing_list').find('.is_first').addClass('active');
    var left_padding = Number($(this).closest('.tabbing_list').find('.is_first').offset().left) + 18;
    left_padding = left_padding + 'px';
    $(this).closest('.tabbing_list').find('.is_first .submenu_custom_tabbing_first').css('padding-left',left_padding);
  });
  $(".main_tabbing .menu_item.custom_tab").hover(function () {
    var left_padding = Number($(this).offset().left) + 17;
    left_padding = left_padding + 'px';
    $(this).find('.submenu_custom_tabbing_first').css('padding-left',left_padding);
  });
  // $("body").on('click','.main_tabbing .menu_item.custom_tab>.heading_anchor',function(e){
  //   e.preventDefault();
  //   $('.main_tabbing .menu_item.custom_tab').removeClass('active');
  //   $(this).closest('.menu_item.custom_tab').addClass('active');
  // });
  $("body").on('click','.menu-item.back_button a',function(e){
    e.preventDefault();
    $(this).closest('.need_fix_menu').removeClass('active');
    $(this).closest('.need_fix_menu').parent().removeClass('nt_opended');
    $(this).closest('.need_fix_menu').parent().find('a.nt_opended').removeClass('nt_opended');
  });
  $("body").on('click','.menu_multi .sub-menu .nav_link_icon',function(e){
    e.preventDefault();
    $(this).closest('li').find('.need_fix_menu').first().addClass('active');
  });
  
  $("body").on('click','#ymq-box .ymq-option-title',function(e){
    e.preventDefault();
    if($(this).hasClass('active')){
      $(this).toggleClass('active');
      $(this).next().toggleClass('active');
    }else{
      $('#ymq-box .ymq-option-title').removeClass('active');
      $('#ymq-box .ymq-option-title').next().removeClass('active');
      $(this).toggleClass('active');
      $(this).next().toggleClass('active');
    }
  });

  $("body").on('click','.img_title_content_wrpr a.button_link',function(e){
    e.preventDefault();
    $(this).closest('.img_title_content_wrpr').find('.box_wrapper_color').slideDown();
  });
  
  $("body").on('change','#ymq-box .ymq-options-box input[type="radio"]',function(){
    if($(this).closest('.ymq-options-box').find('input[type="radio"]:checked').length > 0){
      $('#ymq-box .ymq-option-title').removeClass('active');
      $('#ymq-box .ymq-option-title').next().removeClass('active');
      $(this).closest('.ymq-options-box').next().find('.ymq-option-title').addClass('active');
      $(this).closest('.ymq-options-box').next().find('.ymq-option-title').next().addClass('active');
    }
    window.get_sku();
  });
  
  var timer;
  function mouseStopped(){
      if($(".main_tabbing .menu_item.custom_tab.hover").length > 0){
        $('.main_tabbing .menu_item.custom_tab').removeClass('active');
        $(".main_tabbing .menu_item.custom_tab.hover").addClass('active'); 
      }
  }
  window.addEventListener("mousemove",function(){
    clearTimeout(timer);
    timer=setTimeout(mouseStopped,100);
  });
  
  $(".main_tabbing .menu_item.custom_tab").hover(function () {
    $(this).addClass('hover');
  }, 
  function () {
      $(this).removeClass('hover');
  });
  
  $(document).click(function() {
    var obj = $(".tabbing_list.menu-item");
    if (!obj.is(event.target) && !obj.has(event.target).length) {
      $(".tabbing_list.menu-item").removeClass('menu_item_hover');
      $('.main_tabbing .menu_item.custom_tab').removeClass('active');
    }
  });
  setInterval(function(){
    count_price();
  },1000);

  function get_color_name(){
    if($('#ymq-box .ymq-options-box[data-label="Color"]').length > 0){
      $('#ymq-box .ymq-options-box[data-label="Color"] label').each(function(ii,vv){
        var color_name = $(this).find('.ymq_tooltip_show').text();
        $(this).append('<span class="color_name">'+ color_name +'</span>');
      }); 
      window.get_sku();
    }else{
      setTimeout(function(){
        get_color_name();
      },1000);
    }
  }
  get_color_name();
  function get_Fireglass_name(){
    if($('#ymq-box .ymq-options-box[data-label="Fireglass"]').length > 0){
      $('#ymq-box .ymq-options-box[data-label="Fireglass"] label').each(function(ii,vv){
        var color_name = $(this).find('.ymq_tooltip_show').text();
        $(this).append('<span class="color_name">'+ color_name +'</span>');
      }); 
      window.get_sku();
    }else{
      setTimeout(function(){
        get_Fireglass_name();
      },1000);
    }
  }
  get_Fireglass_name();
  function get_material_name(){
    if($('#ymq-box .ymq-options-box[data-label="Materials"]').length > 0){
      $('#ymq-box .ymq-options-box[data-label="Materials"] label').each(function(ii,vv){
        var color_name = $(this).find('.ymq_tooltip_show').text();
        $(this).append('<span class="color_name">'+ color_name +'</span>');
      }); 
      window.get_sku();
    }else{
      setTimeout(function(){
        get_material_name();
      },1000);
    }
  }
  get_material_name();
  function get_finish_name(){
    if($('#ymq-box .ymq-options-box[data-label="Finish"]').length > 0){
      $('#ymq-box .ymq-options-box[data-label="Finish"] label').each(function(ii,vv){
        var color_name = $(this).find('.ymq_tooltip_show').text();
        $(this).append('<span class="color_name">'+ color_name +'</span>');
      }); 
      window.get_sku();
    }else{
      setTimeout(function(){
        get_finish_name();
      },1000);
    }
  }
  get_finish_name();
  function get_top_color_name(){
    if($('#ymq-box .ymq-options-box[data-label="GFRC Top Color"]').length > 0){
      $('#ymq-box .ymq-options-box[data-label="GFRC Top Color"] label').each(function(ii,vv){
        var color_name = $(this).find('.ymq_tooltip_show').text();
        $(this).append('<span class="color_name">'+ color_name +'</span>');
      });
      window.get_sku();
    }else{
      setTimeout(function(){
        get_top_color_name();
      },1000);
    }
  }
  get_top_color_name();
  function get_base_color_name(){
    if($('#ymq-box .ymq-options-box[data-label="Powder Coat Base Color"]').length > 0){
      $('#ymq-box .ymq-options-box[data-label="Powder Coat Base Color"] label').each(function(ii,vv){
        var color_name = $(this).find('.ymq_tooltip_show').text();
        $(this).append('<span class="color_name">'+ color_name +'</span>');
      });
      window.get_sku();
    }else{
      setTimeout(function(){
        get_base_color_name();
      },1000);
    }
  }
  get_base_color_name();
  $(window).on('load',function () {
    console.log('on load');
    window.get_sku();
  });
  setInterval(function () {
    $(".js_cat_items .js_cart_item.merge_product").each(function () {
      var mid = $(this).attr("data-bundle_id");
      var qty = parseInt($(this).find('input[name="updates[]"]').val());
      var mprice = 0;
      $('.js_cart_item.merge_product[data-bundle_id="' + mid + '"]').each(
        function () {
          mprice += parseInt($(this).attr("data-price"));
        }
      );
      var totalprice = mprice * qty;
      if ($(this).find(".cart_meta_price .cart_price").length > 0) {
        $(this)
          .find(".cart_meta_price .cart_price")
          .text(geckoShopify.formatMoney(mprice));
      }
      if ($("body").find(".cart_page_section").length > 0) {
        $(this)
          .find(".cart_meta_prices .cart_price [data-ymq-original-money]")
          .text(geckoShopify.formatMoney(mprice));
        $(this)
          .find(".cart-item-price [data-ymq-original-money]")
          .text(geckoShopify.formatMoney(totalprice));
      }
    });
  }, 1000);

   setInterval(function () {
        $.getJSON('/cart.json',function(data){
            var all_ids_pro = data.items.map((item) => item.product_id);
            all_ids_pro = all_ids_pro.filter(function (v, i, self) {
                    return i == self.indexOf(v);
            });
            if(all_ids_pro.join("") == '8261001937116'){
              fetch(window.Shopify.routes.root + 'cart/clear.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then(response => {
                console.log("removed");
                if($('#nt_cart_canvas').hasClass('act_opened') && $('.mask-overlay').hasClass('mask_opened')){
                  $('#nt_cart_canvas').removeClass('act_opened');
                  $('.mask-overlay').removeClass('mask_opened');
                  $('html').removeClass('hside_opened');
                  $('body').removeClass('pside_opened');
                }
                $('.tcount.jsccount').html(0);
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            } 
          });
    }, 1000);

  $('body').on('click','.expertwrapper-main a.popclickopen',function(e){
    e.preventDefault();
    if($(this).parent().hasClass('onit')){
      $(this).parent().removeClass('onit');
      $('#'+$(this).attr('data-id')).hide();
    }else{
      $('.expertwrapper-main .popedit').hide();
      $('.expertwrapper-main .wrpinner').removeClass('onit');
      $(this).parent().addClass('onit');
      $('#'+$(this).attr('data-id')).show();
    }
  });
  $('body').on('click','.opencontact-data-head .close-icon',function(e){
    e.preventDefault();
    $(this).parents('.popedit').parent().removeClass('onit');
    $(this).parents('.popedit').hide();
  });
  
  $('body').on('click','.chat_btn_main',function(e){
    e.preventDefault();
    window.tidioChatApi.popUpOpen(true);
  });
  
});

